// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--jp-con-out-st{
    min-height: 100vh;
    width: 100%;
    position: relative;
}

.scl--jppb-con-st{
    width: 100%;
    height: auto;
    position: fixed;
    top: 81px;
    left: 0px;
    z-index: 100;
    display: flex;
    justify-content: center;
    background: linear-gradient(0.67deg, #0A0A0A 2.35%, #141414 98.73%);
}

.scl--jps-con-st{
    width: auto;
    height: auto;
    position: fixed;
    top: 153px;
    left: 0px;
    z-index: 100;
}

.scl--jpo-con-st{
    width: calc(100% - 472px);
    position: fixed;
    top: 153px;
    left: 472px;
}

@media (max-width: 850px) {
    .scl--jpo-con-st{
        width: calc(100% - 240px);
        left: 240px;
    }
}

@media (max-width: 500px) {
    .scl--jppb-con-st{
        top: 117px;
    }

    .scl--jps-con-st{
        position: fixed; 
        top: 189px;
        left: 0;
        height: calc(100vh - 189px);
        transform: translateX(-100%);
        transition: transform 0.35s ease-in-out;
        will-change: transform;     
        z-index: 100;
    }

    .scl--jps-con-st.active{
        transform: translateX(0);
    }

    .scl--jpo-con-st{
        width: 100%;
        top: 189px;
        left: 0px;
        overflow: hidden;
    }
}`, "",{"version":3,"sources":["webpack://./src/layout-module/layout-configuration/outlet/css/jpOutlet.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,SAAS;IACT,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mEAAmE;AACvE;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;IACV,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,UAAU;IACV,WAAW;AACf;;AAEA;IACI;QACI,yBAAyB;QACzB,WAAW;IACf;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,eAAe;QACf,UAAU;QACV,OAAO;QACP,2BAA2B;QAC3B,4BAA4B;QAC5B,uCAAuC;QACvC,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,UAAU;QACV,SAAS;QACT,gBAAgB;IACpB;AACJ","sourcesContent":[".scl--jp-con-out-st{\n    min-height: 100vh;\n    width: 100%;\n    position: relative;\n}\n\n.scl--jppb-con-st{\n    width: 100%;\n    height: auto;\n    position: fixed;\n    top: 81px;\n    left: 0px;\n    z-index: 100;\n    display: flex;\n    justify-content: center;\n    background: linear-gradient(0.67deg, #0A0A0A 2.35%, #141414 98.73%);\n}\n\n.scl--jps-con-st{\n    width: auto;\n    height: auto;\n    position: fixed;\n    top: 153px;\n    left: 0px;\n    z-index: 100;\n}\n\n.scl--jpo-con-st{\n    width: calc(100% - 472px);\n    position: fixed;\n    top: 153px;\n    left: 472px;\n}\n\n@media (max-width: 850px) {\n    .scl--jpo-con-st{\n        width: calc(100% - 240px);\n        left: 240px;\n    }\n}\n\n@media (max-width: 500px) {\n    .scl--jppb-con-st{\n        top: 117px;\n    }\n\n    .scl--jps-con-st{\n        position: fixed; \n        top: 189px;\n        left: 0;\n        height: calc(100vh - 189px);\n        transform: translateX(-100%);\n        transition: transform 0.35s ease-in-out;\n        will-change: transform;     \n        z-index: 100;\n    }\n\n    .scl--jps-con-st.active{\n        transform: translateX(0);\n    }\n\n    .scl--jpo-con-st{\n        width: 100%;\n        top: 189px;\n        left: 0px;\n        overflow: hidden;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
